export default __webpack_public_path__ + "img/logo.e5bcc5d8.png";